import {
  ChartBarSquareIcon, TableCellsIcon, DocumentChartBarIcon, FlagIcon,
  CurrencyDollarIcon, MapIcon, BanknotesIcon,
  ClipboardDocumentCheckIcon, ArrowUpCircleIcon, SparklesIcon,
  PhoneArrowUpRightIcon, UserGroupIcon, ArrowPathIcon, ShieldCheckIcon, ClipboardDocumentListIcon,
  DocumentTextIcon,
  ArrowsRightLeftIcon, UserIcon, UsersIcon, BookOpenIcon, AcademicCapIcon,
  QueueListIcon,
  ChatBubbleLeftRightIcon,
} from '@heroicons/react/24/outline';
import { ROLES } from '../config/rolePermissions';

/** Leads Tracker sidenav â workflow sections + links to main-app Clients / Team. */
export const LEADS_NAV = [
  {
    label: 'Performance',
    items: [
      { name: 'Overview', href: '/leads/overview', icon: ChartBarSquareIcon },
      { name: 'Lead Quality & Tracker', href: '/leads/tracker', icon: TableCellsIcon },
      { name: 'Reporting', href: '/leads/reporting', icon: DocumentChartBarIcon },
      { name: 'Red Flags', href: '/leads/red-flags', icon: FlagIcon },
    ],
  },
  {
    label: 'Budget & Market',
    items: [
      { name: 'Targets', href: '/leads/targets', icon: CurrencyDollarIcon },
      { name: 'Market Intel', href: '/leads/market-intel', icon: MapIcon },
      { name: 'Spend & Source', href: '/leads/spend-source', icon: BanknotesIcon },
    ],
  },
  {
    label: 'Ads',
    items: [
      { name: 'Ad Audits', href: '/leads/ad-audits', icon: ClipboardDocumentCheckIcon },
      { name: 'Ads Escalation', href: '/leads/ads-escalation', icon: ArrowUpCircleIcon },
      { name: 'AI Analyst', href: '/leads/analyst', icon: SparklesIcon },
    ],
  },
  {
    label: 'Operations',
    items: [
      { name: 'Operations Guide', href: '/leads/operations-guide', icon: AcademicCapIcon },
      { name: 'Call Script', href: '/leads/call-script', icon: ChatBubbleLeftRightIcon },
      { name: 'Call Center', href: '/leads/call-center', icon: PhoneArrowUpRightIcon },
      { name: 'Front Office Gap', href: '/leads/front-office', icon: UserGroupIcon },
      { name: 'Reactivation', href: '/leads/reactivation', icon: ArrowPathIcon },
      /* Today's ranked twenty, across every location. ABOVE the QC Queue: it is
         where the reviewer's day starts, and the Queue is where they go to read
         one client's month. */
      { name: 'Today’s Review', href: '/leads/qc-review', icon: ShieldCheckIcon },
      { name: 'QC Queue', href: '/leads/qc', icon: ShieldCheckIcon },
      { name: 'To-Do', href: '/leads/todo', icon: ClipboardDocumentListIcon },
      { name: 'Work List Tracker', href: '/leads/worklists', icon: QueueListIcon },
      // Leads vs bookings, month over month â the sheet a practice reads at
      // month end, on screen and as a download.
      { name: 'Report', href: '/leads/report', icon: DocumentChartBarIcon },
    ],
  },
  {
    label: 'Setup',
    items: [
      { name: 'My Team', href: '/my-team', icon: UsersIcon, external: true, global: true, roles: [ROLES.MANAGER] },
    ],
  },
  {
    label: 'Client Reporting',
    items: [
      { name: 'Meeting Notes', href: '/leads/meeting-notes', icon: DocumentTextIcon },
    ],
  },
  {
    label: 'Data',
    items: [
      { name: 'GHL \u2192 PMS', href: '/leads/pms', icon: ArrowsRightLeftIcon },
      { name: 'Lead Detail', href: '/leads/leads', icon: UserIcon },
      { name: 'Documentation', href: '/leads/docs', icon: BookOpenIcon, global: true },
    ],
  },
];

/** Role-filtered sidenav (mirrors main Sidebar â My Team is manager-only). */
export function filterLeadsNav(user) {
  return LEADS_NAV
    .map((section) => ({
      ...section,
      items: section.items.filter((item) => {
        if (item.roles && !item.roles.includes(user?.role)) return false;
        return true;
      }),
    }))
    .filter((section) => section.items.length > 0);
}

export function leadsPageTitle(pathname) {
  const all = LEADS_NAV.flatMap((s) => s.items);
  const match = all.find((i) =>
    i.end ? pathname === i.href : pathname === i.href || pathname.startsWith(`${i.href}/`),
  );
  return match?.name || '';
}
